/**
 * Formata números com separadores de milhares / Format numbers with thousands separators
 */
export function formatNumber(number) {
    if (!number && number !== 0) return '0';
    return new Intl.NumberFormat('pt-BR').format(number);
}

/**
 * Formata tempo de execução para exibição / Format execution time for display
 */
export function formatExecutionTime(time) {
    if (!time && time !== 0) return '-';
    if (time < 1000) {
        return Math.round(time) + 'ms';
    }
    return (time / 1000).toFixed(2) + 's';
}

/**
 * Formata percentual com 1 casa decimal / Format percentage with 1 decimal place
 */
export function formatPercentage(percentage) {
    if (!percentage && percentage !== 0) return '0.0';
    return Number(percentage).toFixed(1);
}

/**
 * Retorna classe CSS baseada no tipo de erro / Return CSS class based on error type
 */
export function getErrorTypeClass(errorType) {
    const classes = {
        'connect_error': 'bg-danger text-white',
        'server_error': 'bg-warning text-dark',
        'client_error': 'bg-info text-white',
        'internal_error': 'bg-secondary text-white',
        'api_error': 'bg-primary text-white'
    };
    return classes[errorType] || 'bg-secondary text-white';
}

/**
 * Retorna classe CSS baseada no status da integração / Return CSS class based on integration status
 */
export function getStatusBadgeClass(status) {
    const classes = {
        'success': 'bg-success text-white',
        'error': 'bg-danger text-white',
        'timeout': 'bg-warning text-dark',
        'processing': 'bg-info text-white'
    };
    return classes[status] || 'bg-secondary text-white';
}

/**
 * Retorna label do status / Return status label
 */
export function getStatusLabel(status) {
    const labels = {
        'success': 'Sucesso',
        'error': 'Erro',
        'timeout': 'Timeout',
        'processing': 'Processando'
    };
    return labels[status] || status;
}

/**
 * Retorna classe CSS baseada no status da integração para o modal / Return CSS class based on integration status for modal
 */
export function getIntegrationStatusClass(status) {
    const classes = {
        'success': 'status-success',
        'error': 'status-error',
        'timeout': 'status-timeout',
        'processing': 'status-processing'
    };
    return classes[status] || 'status-default';
}

/**
 * Retorna classe CSS baseada no status da reserva / Return CSS class based on reservation status
 */
export function getReservationStatusClass(status) {
    const statusClasses = {
        1: 'status-pre-reserva',
        2: 'status-reservado',
        3: 'status-cancelado',
        4: 'status-retirado',
        5: 'status-devolvido'
    };
    return statusClasses[status] || 'status-default';
}



/**
 * Retorna label do tipo de erro / Return error type label
 */
export function getErrorTypeLabel(errorType) {
    const labels = {
        'connect_error': 'Erro de Conexão',
        'server_error': 'Erro do Servidor',
        'client_error': 'Erro da Requisição',
        'internal_error': 'Erro Interno',
        'api_error': 'Erro de API'
    };
    return labels[errorType] || errorType;
}

/**
 * Retorna label do método / Return method label
 */
export function getMethodLabel(method) {
    const labels = {
        'authenticate': 'Autenticação',
        'user': 'Dados do Usuário',
        'setReserve': 'Criar Reserva',
        'updateReserve': 'Atualizar Reserva'
    };
    return labels[method] || method;
}

/**
 * Retorna classe CSS baseada no código HTTP / Return CSS class based on HTTP code
 */
export function getHttpStatusClass(statusCode) {
    if (statusCode >= 200 && statusCode < 300) {
        return 'text-success font-weight-bold';
    } else if (statusCode >= 400 && statusCode < 500) {
        return 'text-warning font-weight-bold';
    } else if (statusCode >= 500) {
        return 'text-danger font-weight-bold';
    }
    return 'text-secondary';
}

export function getMethodIcon(method) {
    const icons = {
        'authenticate': 'fas fa-key',
        'user': 'fas fa-user',
        'setReserve': 'fas fa-plus-circle',
        'updateReserve': 'fas fa-edit'
    };
    return icons[method] || 'fas fa-cog';
}

export function getErrorIcon(errorType) {
    const icons = {
        'connect_error': 'fas fa-wifi',
        'server_error': 'fas fa-server',
        'client_error': 'fas fa-user-times',
        'internal_error': 'fas fa-bug',
        'api_error': 'fas fa-code'
    };
    return icons[errorType] || 'fas fa-exclamation';
}



// WEBPACK FOOTER //
// ./src/composables/mask.js